import React from "react";
import { connect, useSelector } from "react-redux";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import styled from "styled-components";

import { fontWeights, sizes } from "../constant/styles";
import ACTIONS from "../store/action";
import { PRIMARY_50, PRIMARY_100, PRIMARY_600, PRIMARY_700, GRAY_100, GRAY_400 } from "../constant/colors";
import { formPopupsContentKeys } from "../constant/formPopupsContentKeys";
import { selectFilters, selectSelectedView } from "../store/selector";
import {
  useStandardizedTracking,
  EventNames,
  ContentTypes,
  FeatureGroups,
  EEContentKeys
} from "../utils/pendo/useStandardizedTracking";
import { getPageKeyForSelectedView } from "../utils/pendo/getPageKeyForSelectedView";

const StyledButton = styled.button`
  font-size: ${sizes.medium};
  font-weight: ${fontWeights.semibold};
  background: ${(props) => (props.disabled ? GRAY_100 : PRIMARY_50)};
  color: ${(props) => (props.disabled ? GRAY_400 : PRIMARY_600)};
  border: none;
  border-radius: 6px;
  padding: 4px 16px;
  height: 31px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  white-space: nowrap;

  &:hover {
    background: ${(props) => (props.disabled ? GRAY_100 : PRIMARY_100)};
    color: ${(props) => (props.disabled ? GRAY_400 : PRIMARY_700)};
  }

  &:focus {
    outline: none;
  }
`;

const SaveAsNewListComponent = ({ t, id, setFormPopupsAct, disabled }) => {
  const { track } = useStandardizedTracking();
  const filters = useSelector(selectFilters);
  const selectedView = useSelector(selectSelectedView);

  // Opening the save-as-new-list form does NOT prompt — saving a list is not
  // "leaving" the bulk-action context (mirrors clicking Manage Patient Details).
  // If the user later clicks "View List" and navigates away while the bulk panel
  // is still dirty, the global BulkActionNavGuard catches that navigation instead.
  const handleClickButton = (e) => {
    e.stopPropagation();
    e.currentTarget.blur();
    if (disabled) return;
    track(EventNames.BUTTON_CLICK, {
      pageKey: getPageKeyForSelectedView(selectedView),
      featureGroup: FeatureGroups.SAVED_LISTS,
      contentType: ContentTypes.BUTTON,
      contentKey: EEContentKeys.SAVE_AS_NEW_LIST_BTN,
      additionalInfo: {
        ee_filter_active: filters?.expressEnrollEligible || false
      }
    });
    setFormPopupsAct(true, formPopupsContentKeys.ADD_NEW_LIST, true);
  };

  return (
    <StyledButton onClick={handleClickButton} disabled={disabled} id={id}>
      {t("save_as_new_list")}
    </StyledButton>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setFormPopupsAct: (visible, contentKey, isDuplicateMode) =>
    dispatch(ACTIONS.setFormPopups(visible, contentKey, isDuplicateMode))
});

const SaveAsNewList = compose(withTranslation(), connect(null, mapDispatchToProps))(SaveAsNewListComponent);

export default SaveAsNewList;
